/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rankings_Col_RankInputs */



/**
* | output |
* | --- |
* | "#" |
*
* @param {Rankings_Col_RankInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const rankings_col_rank = /** @type {((inputs?: Rankings_Col_RankInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rankings_Col_RankInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("#")
	if (locale === "es") return /** @type {LocalizedString} */ ("#")
	if (locale === "pt") return /** @type {LocalizedString} */ ("#")
	if (locale === "it") return /** @type {LocalizedString} */ ("#")
	return /** @type {LocalizedString} */ ("#")
});